import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-usage" }),
  /*#__PURE__*/_createTextVNode(" Basic usage ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = { class: "block" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "demonstration" }, "When you have few pages", -1)
const _hoisted_6 = { class: "block" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "demonstration" }, "When you have more than 7 pages", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          total: 50
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          total: 1000
        })
      ]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
}